import type { VoidFunctionComponent } from 'react';
import * as React from 'react';
import moment from 'moment';

import type { SnapshotFilters } from '../../../../shared/issuesV2/snapshots';
import Button from '../../generic/Button';
import ModalDateRangePicker from '../../modals/ModalDateRangePicker';

type Props = {
  filters: SnapshotFilters;
  setDates: (start: Date, end: Date) => void;
  isDisabled: boolean;
};

/**
 * Dropdown menu for filtering by Date on the Issue Overview page.
 */
const DateFilter: VoidFunctionComponent<Props> = ({ filters, setDates, isDisabled }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <Button type="secondary" onClick={() => setIsOpen(true)} isDisabled={isDisabled}>
        {moment(filters.start).format('ll')} - {moment(filters.end).format('ll')}
      </Button>
      <ModalDateRangePicker
        show={isOpen}
        startDate={filters.start}
        endDate={filters.end}
        // The date picker gives us dates at midnight, so we round to the end of the day.
        onSetDateRange={({ startDate, endDate }) => setDates(startDate, moment(endDate).endOf('day').toDate())}
        onHide={() => setIsOpen(false)}
        />
    </>
  );
};

export default DateFilter;
